import { ImageUploadField } from '../../components/forms.tsx';
import { z } from 'zod';
import { Form } from '@remix-run/react';
import { getFieldsetConstraint, parse } from '@conform-to/zod';
import { useForm } from '@conform-to/react';
import { ActionFunctionArgs, json } from '@remix-run/node';
import { persistTemporaryFile } from '../../models/AssetModel.js';

export const ImageUploadSchema = z.object({
	image: z.string(),
});

export async function action({ request }: ActionFunctionArgs) {
	const formData = await request.formData();
	const submission = parse(formData, {
		schema: ImageUploadSchema,
	});

	if (!submission.value) {
		return json(
			{
				status: 'error',
				submission,
			} as const,
			{ status: 400 },
		);
	}

	const { image } = submission.value;
	await persistTemporaryFile(image);
	return json(
		{
			status: 'success',
			submission,
		} as const,
		{ status: 200 },
	);
}

export default function ImageUploadDemo() {
	// useActionData<typeof action>()
	const [form, fields] = useForm({
		id: 'image-upload-demo',
		constraint: getFieldsetConstraint(ImageUploadSchema),
		// lastSubmission: bargainEditorFetcher.data?.submission,
		onValidate({ formData }) {
			return parse(formData, { schema: ImageUploadSchema });
		},
		defaultValue: {
			files: [],
		},
		shouldRevalidate: 'onBlur',
	});

	return (
		<main className="relative min-h-screen sm:flex sm:items-center sm:justify-center">
			<div className="relative sm:pb-16 sm:pt-8">
				<div className="mx-auto max-w-7xl sm:px-6 lg:px-8">
					<Form
						method="post"
						className="flex h-full min-w-[368px] max-w-xl flex-col gap-1"
						{...form.props}
					>
						<ImageUploadField
							label={'Upload your files'}
							field={fields.image}
							maxFiles={1}
						/>
						<button type="submit">Formular absenden</button>
					</Form>
				</div>
			</div>
		</main>
	);
}
